module.exports = __webpack_public_path__ + "img/optionsmenu-ar.019c23ae.png";